var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.4736C6.82843 13.4736 7.5 12.8033 7.5 11.9765C7.5 11.1497 6.82843 10.4795 6 10.4795C5.17157 10.4795 4.5 11.1497 4.5 11.9765C4.5 12.8033 5.17157 13.4736 6 13.4736Z",
    fill: "#9295A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.4736C12.8284 13.4736 13.5 12.8033 13.5 11.9765C13.5 11.1497 12.8284 10.4795 12 10.4795C11.1716 10.4795 10.5 11.1497 10.5 11.9765C10.5 12.8033 11.1716 13.4736 12 13.4736Z",
    fill: "#9295A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.4736C18.8284 13.4736 19.5 12.8033 19.5 11.9765C19.5 11.1497 18.8284 10.4795 18 10.4795C17.1716 10.4795 16.5 11.1497 16.5 11.9765C16.5 12.8033 17.1716 13.4736 18 13.4736Z",
    fill: "#9295A3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.d800c49483c210b0764d48ed0d04bff5.svg";
export { ForwardRef as ReactComponent };